import React, { Component } from 'react';
import PropTypes from "prop-types";
import FormControl from "../-FormControl";
import { toast } from '@platform/api';
import { isFunction } from 'util';
import { getMultiLang, getDataFormatFromCache } from '@platform/api';
import { formatNumber } from './format';
import { NEED_SELECTION_ITEMS } from '../-FormControl/constants';
import { getSysFieldid, ViewModel } from '@platform/api';
import Calculator from '../Calculator';
import Big from "big.js";

const propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    onBlur: PropTypes.func,
    onChange: PropTypes.func,
};

const defaultProps = {
    verify: true,
    scale: 0,
    disabled: false,
    showFractile: true,
    value: '',
};

// 满足number类型的输入，但是非有效数字
const specialNumber = new Set(['+', '-', '.']);

let { getGlobalStorage } = ViewModel;

// 四舍五入
function ncRounding(value, scale) {
    // 如果没有精度，不需要处理四舍五入
    if (!scale) { return value; }

    let [_value, _scale] = [value, scale];

    if (
        !Object.prototype.toString.call(scale) !== '[object Number]' &&
        !isNaN(Number(scale))
    ) { _scale = Number(scale); }

    // 校验参数
    if (Object.prototype.toString.call(value) !== '[object String]') { _value = String(value); }

    //移除千分位
    // _value = _value.replace(/\,/gi, "");

    const re = /^(\-|\+)?(\d+)?\.?(\d+)?$/;

    if (_value && _value.length < 500 && !re.test(_value)) {
        console.warn('处理参数异常');
        return value;
    }

    // 分割value
    let [beforePoint, afterPoint] = _value.split('.');

    // 有小数位数
    if (afterPoint && afterPoint !== '') {
        // 判断小数位数与精度的关系
        if (afterPoint.length > _scale) {
            _value = Number(_value);
            // 进行四舍五入操作
            _value = Number(_value.toFixed(_scale + 1));

            _value = _value * Math.pow(10, _scale);

            _value = Math.round(_value);

            _value = _value / Math.pow(10, _scale);
            // NCC-153655 截取精度没有转string导致replace报错
            _value = String(_value);
        }
    }

    return _value;
}

/**
 * 这个组件目前有些乱  首先要清楚  组件需要什么 组件输出什么
 * 组件是受控和非受控的
 * 需要value、scale、min、max、maxlength等
 * 其中value最重要，那么首先定下基调，受控（事件驱动）和 非受控（state驱动）情况下的value都应该是纯数字
 * 一般不输出千分位，千分位只是展示 
 */
class NumberInput extends Component {
    constructor(props) {
        super(props);
        // 初始化 clear zero
        let { value = '', scale, maxlength } = this.props;
        // 处理下value
        value = this.getHandleValue(this.props);
        this.state = {
            value,
            verify: props.verify,
            reg: new RegExp('^[-|0-9]+(\\.[0-9]{0,' + props.scale + '})?$'),
            // 多语
            LangData: null,
            json: {},
            style: { textAlign: 'right' },
        };
        let numberDataFormat = getDataFormatFromCache();
        this.formatDocVO = numberDataFormat.fm.nfm;
        this.isFocus = false;
        this.onFocus = false;
        this.nccTable = JSON.parse(getGlobalStorage('localStorage', 'nccTable')) || {};
    }

    componentWillReceiveProps(nextProps) {
        let {
            value = '', scale,
            noDataFormat = false,
            verify,
            style = {},
        } = nextProps;
        value = String(value ?? '');

        if (value.indexOf('-') !== -1 && this.formatDocVO.negativeFormat.red && !noDataFormat) {
            style.color = 'red';
        }

        let prevState = this.state;
        value = this.getHandleValue(nextProps, this.isFocus);
        // 不聚焦时 才进行更新  否则不接收外部的数据  这么坑的逻辑是谁同意的  // NCC-138142
        if (!this.isFocus) {
            // 不轻易更新
            if (value !== prevState.value ||
                verify !== prevState.verify ||
                style.color !== prevState.style.color ||
                scale !== prevState.scale
            ) {
                this.setState({
                    value,
                    style: {
                        textAlign: 'right',
                        color: style.color,
                    },
                    verify,
                    reg: new RegExp('^[-|0-9]+(\\.[0-9]{0,' + scale + '})?$'),
                });
            }
        }
    }

    componentWillMount() {
        // 初始化调用getPlatformLang方法获取多语
        let callback = (json, bool, LangData) => {
            this.setState({ json, LangData }, () => {
                //  在这里进行之前组件willMount的操作，比如加载缓存之类的
            });
        };
        getMultiLang({ moduleId: 'base_ncnumber', callback }); // moduleId为所需加载json文件夹名称前缀
    }

    componentWillUnmount() {
        this.props.showFractile && this.nccTable.inputdataformat && this.numberDom.removeEventListener('copy', this.handleCopy);
        this.numberDom = null;
    }

    componentDidMount() {
        let { scale, value, noDataFormat = false, style = {}, showFractile } = this.props;

        value = String(value || '');

        if (value.indexOf('-') !== -1 && this.formatDocVO.negativeFormat.red && !noDataFormat) {
            style.color = 'red';
        }

        value = this.getHandleValue(this.props);

        this.setState({
            value,
            style: {
                textAlign: 'right',
                color: style.color,
            },
        });
        // 拷贝事件
        showFractile && this.nccTable.inputdataformat && this.numberDom.addEventListener('copy', this.handleCopy);
    }

    // 处理拷贝
    handleCopy = event => {
        var clipboardData = window.clipboardData || event.clipboardData;
        if (!clipboardData) {
            return;
        }
        let $target = event.target;
        let text = '';
        // 兼容所有浏览器
        if ($target) {
            text = $target.value.substring(
                $target.selectionStart,
                $target.selectionEnd,
            );
        }
        if (text) {
            event.preventDefault();
            let milSymbol = this.formatDocVO.milSymbol || ',';
            text = this.removeThousands(text || '', milSymbol);
            clipboardData.setData("text", text);
        }
    };

    // 获取处理后的值
    getHandleValue = (props, isFocus) => {
        let { value = '', scale, maxlength = Infinity, isFillZero = true } = props;
        // 判空
        value = String(value || '');
        // 校验长度  精度处理  去除千分位
        value = this.checkLength(ncRounding(this.removeThousands(value), scale), maxlength);
        if (value && String(scale) && !isFocus) {
            // 如果数据有小数点尝试四舍五入
            if (value.includes('.')) {
                value = ncRounding(value, scale);
            }
            if (isFillZero) {
                value = this.addZero(value, scale); // 有没有 小数点  都需要补零 by bbqin
            }

        }
        return value;
    }

    handleFocus = e => {
        let { onFocus, scale } = this.props;
        let { value } = this.state;

        this.onFocus = true;

        if (isFunction(onFocus)) {
            onFocus(e);
        }
        this.setState({ value }, () => {
            let inputDom = this.numberDom.querySelector('input');
            this.mouseDown !== true &&
                inputDom &&
                NEED_SELECTION_ITEMS.includes(this.props.itemtype) &&
                this.executeSelection(inputDom);
        });

    };

    executeSelection = inputDom => {
        try {
            let length = inputDom.value.length;
            inputDom.setSelectionRange(0, length);
        } catch (ex) {
            console.log(ex);
        }

    };

    // 控制光标位置
    setCursorPosition = (elem, index) => {
        var val = elem.value;
        var len = val.length;
        index--;
        // 超过文本长度直接返回
        if (len < index) { return; }
        elem.focus();
        if (elem.setSelectionRange) {
            // 标准浏览器
            elem.setSelectionRange(index, index);
        } else {
            // IE9- 这个里面有问题在看
            var range = elem.createTextRange();
            range.moveStart('character', -len);
            range.moveEnd('character', -len);
            range.moveStart('character', index);
            range.moveEnd('character', 0);
            range.select();
        }
    };
    handleKeyDown = event => {
        // NCC-282213 按下等号或者空格处理为失焦状态，便于更新数据
        if (event.keyCode == 187 || event.keyCode == 32) {
            this.isFocus = false;
        }
        // event.stopPropagation();
        let { onKeyDown } = this.props;
        if (isFunction(onKeyDown)) {
            onKeyDown(event);
        }
    }

    handleChange = (newValue, e) => {
        newValue = newValue.replace('。', '.');
        let milSymbol = this.formatDocVO.milSymbol || ',';
        let showFractile = this.props.showFractile;
        // wangyang start  光标控制
        this.isFocus = true;
        // const re = /^(\-|\+)?(\d+)+\.?(\d+)?$/;
        newValue = this.removeThousands(newValue)
        if (/\s/.test(newValue)) {
            this.isFocus = false;
        }

        if (/=/.test(newValue)) {
            this.isFocus = false;
        }

        let $target = e.target;
        let prevIndex = $target.selectionStart;

        // 解决只删除逗号的情况
        if (this.deleteTrigger) {
            let { value: oldValue } = this.state;
            oldValue = this.commafy(this.removeThousands(oldValue));
            let tempValue = this.commafy(this.removeThousands(newValue));
            let StringVal = typeof newValue === 'string' ? newValue.replace(/\'/g, '').replace(/\"/g, '') : newValue;
            // change了只删除了逗号的情况
            if (StringVal !== oldValue && oldValue.length - StringVal.length === 1 && tempValue == oldValue) {
                // 去除一个字符
                if (this.deleteTrigger === 'delete') {
                    newValue = tempValue.substring(0, prevIndex) + tempValue.substring(prevIndex + 2);
                    prevIndex = prevIndex + 1;
                } else {
                    newValue = tempValue.substring(0, prevIndex - 1) + tempValue.substring(prevIndex + 1);
                    prevIndex = prevIndex - 1;
                }
                newValue = this.removeThousands(newValue);
            }

        }

        // 记录下键入是的坐标位置
        let surplus = $target ? String($target.value || '').substring(prevIndex) : '';

        // 移除千分位
        newValue = this.removeThousands(newValue || '', milSymbol);

        //修改正则 修复del不能删除问题
        const re = /^(\-|\+)?(\d+)?\.?(\d+)?$/;
        if (newValue.length != 0 && newValue.length < 500 && !re.test(newValue) && newValue !== '-') {
            // 当newValue === '-' 时 前面的校验不通过  !re.test(newValue) 为true 会导致-号无法删除  --bbqin
            setTimeout(() => {
                this.setCursorPosition($target, prevIndex);
            }, 10);
            return;
        }
        // end wangyang  光标控制
        // start wanglong sacle maxlength
        let flag = true,
            { value, reg, verify } = this.state;
        let { onChange, scale = 0, maxlength } = this.props;
        // scale maxlength 移除千分位
        scale = Number(scale) > 0 ? Number(scale) : 0;
        maxlength = Number(maxlength) > 0 ? Number(maxlength) : Infinity;
        // 整数部分
        let intValue = newValue.split('.')[0];
        let scaleValueLength = newValue.split('.')[1]
            ? newValue.split('.')[1].length
            : 0;
        let intValueLength = maxlength - (scale != 0 ? scale + 1 : 0);
        let isValid = intValue.length <= intValueLength && scaleValueLength <= scale;

        // 保证长度超长时也可以删除
        if (isValid || this.deleteTrigger) {
            newValue = this.formatDot(newValue, scale);
            if (typeof onChange === 'function') {
                onChange(newValue, e);
            }

            this.setState({
                value: newValue,
                verify,
            }, () => {
                if (showFractile && this.nccTable.inputdataformat && $target && $target.value !== undefined) {
                    // 转换为带千分位的数值
                    let nextValue = this.commafy(newValue);
                    // 取出左边部分
                    let nextInteger = nextValue.substring(0, nextValue.length - surplus.length);
                    this.setCursorPosition($target, nextInteger.length + 1);
                }
            });
        }
        if (!isValid) {
            // sacle 不提示
            if (scaleValueLength > scale) {
                return;
            }

            let title = this.state.json['base-ncnumber-0001'];
            let tip = this.state.json['base-ncnumber-0007'] || '';
            let len = maxlength - scale;
            if (scale > 0) {
                len -= 1;
            }
            if (tip) {
                tip = tip.replace('@', maxlength).replace('$', len).replace('&', scale);
            }
            toast({
                mark: 'number_toast',
                color: 'danger',
                title,
                content: tip,
            });
            // e.target.blur();
        }
        this.deleteTrigger = null;
    };

    //校验数值是否在合法区间内
    checkNumberRange = value => {
        const { max, min } = this.props;
        if (max || max == 0) {
            if (Number(value) > Number(max)) {
                return false;
            }
        }
        if (min || min == 0) {
            if (Number(value) < Number(min)) {
                return false;
            }
        }
        return true;
    };

    handleBlur = (newValue, e) => {
        let { isFillZero = true } = this.props;
        let numberValue = this.props.value;
        let style = { textAlign: 'right' };
        if (String(numberValue).indexOf('-') !== -1 && this.formatDocVO.negativeFormat.red) {
            style.color = 'red';
        }
        let originValue = newValue;
        this.isFocus = false;
        this.onFocus = false;
        this.mouseDown = false;
        // 阻止了Item的blur事件
        // e.stopPropagation();
        let { value, reg, verify } = this.state;
        const {
            onChange,
            scale,
            isrequired,
            onBlur,
            maxlength,
            max,
            min,
        } = this.props;

        let tempValue = String(newValue).replace(/\s*/g, ''); // 去空格
        // 只有负号的情况  变空
        if (specialNumber.has(tempValue)) {
            newValue = '';
        }

        newValue = this.removeThousands(newValue || '', this.formatDocVO.milSymbol || ',');
        newValue.replace('。', '.');

        // 如果value值不为空，就不进行去零处理
        if (newValue != '') {
            let [_integer, _decimal] = newValue.split('.');
            _integer = _integer.replace(/^0*/, '');
            _integer = _integer ? _integer : '0';
            _decimal = _decimal || "";
            newValue = _integer + '.' + _decimal;
        }

        // 整数
        if (!(Number(scale) > 0)) {
            newValue = newValue.split('.')[0];
        }

        // 整数部分
        let integerNumString = newValue.split('.')[0] + '';

        // ------- 修复最大值最小值
        if (originValue || originValue == '0') {
            if (max || max == 0) {
                if (Number(newValue) > Number(max) || integerNumString.length > 20) {
                    if (min || min == 0) {
                        let description = this.state.json['base-ncnumber-0003'];
                        toast({
                            color: 'warning',
                            content: `${description}[${min},${max}]`,
                            mark: 'base_number_maxmin',
                        });
                    } else {
                        let descriptionMax = this.state.json['base-ncnumber-0004'];
                        toast({
                            color: 'warning',
                            content: `${descriptionMax}${max}`,
                            mark: 'base_number_maxmin',
                        });
                    }
                    // console.log('handleBlur', value);
                    //清空number值
                    this.setState({
                        value: '',
                        style,
                    });
                    //清空父组件(表单或表格值)
                    if (typeof onChange === 'function') {
                        onChange('');
                    }
                    if (typeof onBlur === 'function') {
                        onBlur('');
                    }
                    return;
                    //newValue = max;
                }
            }
            if (min || min == 0) {
                if (Number(newValue) < Number(min)) {
                    if (max || max == 0) {
                        let description = this.state.json['base-ncnumber-0003'];
                        toast({
                            color: 'warning',
                            content: `${description}[${min},${max}]`,
                            mark: 'base_number_maxmin',
                        });
                    } else {
                        let descriptionMin = this.state.json['base-ncnumber-0005'];
                        toast({
                            color: 'warning',
                            content: `${descriptionMin}${min}`,
                            mark: 'base_number_maxmin',
                        });
                    }
                    // console.log('handleBlur', value);
                    //清空number值
                    this.setState({
                        value: '',
                        style: style,
                    });
                    //清空父组件(表单或表格值)
                    if (typeof onChange === 'function') {
                        onChange('');
                    }
                    if (typeof onBlur === 'function') {
                        onBlur('');
                    }
                    return;
                    //newValue = min;
                }
            }
        }

        if (scale && Number(scale) > 0 && isFillZero) {
            newValue = this.addZero(newValue, scale);
        }
        // ------- 修复最大值最小值

        // 原来判断  if (reg.test(newValue) || newValue === "")
        if (reg.test(newValue)) {
            if (this.checkNumberRange(newValue)) {
                verify = true;
                if (isFillZero) {
                    value = this.addZero(newValue, scale);
                }
                if (typeof onChange === 'function' && originValue != value) {
                    onChange(value);
                }
            } else {
                value = '';
                verify = false;
            }
        } else if (newValue !== "") {
            verify = false;
            value = this.addZero('0', scale);
            if (typeof onChange === 'function') {
                onChange(value);
            }
        }

        if (isrequired && newValue == '') {
            verify = false;
        }

        // if (typeof onChange === 'function') {
        //     onChange(value);
        // }

        value = this.checkLength(
            ncRounding(this.removeThousands(value), scale),
            maxlength,
        );
        //目前看来这里的逻辑已经看不懂了，只处理特定情况，不影响其他
        if (new Set(['.', '+', '-']).has(value)) {
            value = this.getHandleValue(this.props, this.isFocus);
            if (typeof onChange === 'function' && originValue != value) {
                onChange(value);
            }
        }

        if (typeof onBlur === 'function') {
            onBlur(value);
        }

        // console.log('handleBlur', value);
        this.setState({
            value,
            verify,
            style: style,
        });
    };

    // 补0
    addZero(num, scale) {
        num = String(num);
        num = this.removeThousands(num);
        if (specialNumber.has(num)) {
            num = '0';
        }
        // 如果value值不为空，就不进行去零处理
        if (num != '' && num.includes('.')) {
            let [_integer, _decimal] = num.split('.');
            _integer = _integer.replace(/^0*/, '');
            _integer = _integer ? _integer : '0';
            _decimal = _decimal || "";
            num = _integer + '.' + _decimal;
        }
        if (isNaN(Number(num)) || !num) {
            return '';
        }

        if (scale > 0) {
            let start = num.split('.')[0];
            start = start.replace(/^0*/, '');
            start = start ? start : '0';
            let end = num.split('.')[1];
            if (!end) {
                end = '';
            }
            let len = end.length;
            if (len < scale) {
                end = end.padEnd(scale, '0');
            }
            return start + '.' + end;
        } else {
            // 非安全数字，转number会出现数据错误。 如 9999999999999999 === 10000000000000000
            if (Math.abs(num) > Number.MAX_SAFE_INTEGER) {
                return String(num);
            }
            num = String(Number(num));
            return num;
        }
    }

    //移除千分位
    removeThousands(val, reg = ',') {
        if (val === null || val === undefined) { return ''; }
        reg = new RegExp(`\\${reg}`, 'gi');
        return String(val) ? String(val).replace(reg, '') : '';
    }

    //数字转换成千分位 格式
    commafy(num) {
        let pointIndex,
            intPart,
            pointPart;
        if (num === '-') {
            return '-';
        }
        if (isNaN(num)) {
            return '';
        }

        num = num + '';
        if (num.length < 500 && /^.*\..*$/.test(num)) {
            pointIndex = num.lastIndexOf('.');
            intPart = num.substring(0, pointIndex);
            pointPart = num.substring(pointIndex + 1, num.length);
            intPart = intPart + '';
            let re = /(-?\d+)(\d{3})/;
            while (intPart.length < 500 && re.test(intPart)) {
                intPart = intPart.replace(re, '$1,$2');
            }
            num = intPart + '.' + pointPart;
        } else {
            num = num + '';
            let re = /(-?\d+)(\d{3})/;
            while (num.length < 500 && re.test(num)) {
                num = num.replace(re, '$1,$2');
            }
        }
        // num = num.replace(/,/g, this.formatDocVO.milSymbol);
        return num;
    }

    // 精度处理
    formatDot(value, scale = 6) {
        let formatVal,
            dotSplit,
            val;
        // 解决number 组件可以输入 "00"
        if (value && specialNumber.has(value)) {
            val = value.toString();
        } else {
            // number超过16位数字 会解析出错
            val = Number.isSafeInteger(value) ? Number(value).toString() : value.toString();
        }
        dotSplit = val.split('.');
        if (dotSplit.length > 2 || !value) {
            return value;
        }
        if (val.indexOf('.') > -1) {
            if (scale == 0) {
                formatVal = dotSplit[0];
            } else {
                // 向下取整模式
                formatVal = val.substring(0, val.indexOf('.') + scale + 1);
            }
        } else {
            formatVal = val;
        }

        return formatVal;
    }

    checkLength(value) {
        value = String(value);
        // if (value) {
        //     if (value.length <= maxlength || maxlength === undefined) {
        //         return value;
        //     } else {
        //         return value;
        //         // return value.substring(value.length - maxlength, value.length);
        //     }
        // } else {
        //     return value;
        // }
        return value;
    }

    render() {
        let { suffix, fieldid, scale, noDataFormat = false, showFractile, ...others } = this.props;
        let { value, verify, style } = this.state,
            errorMsg = null,
            errorBorder = '';
        // 添加千分位
        if ((this.formatDocVO.useMil && showFractile && this.nccTable.inputdataformat) || (!this.onFocus && !noDataFormat)) {
            value = this.commafy(value);
        }

        if (!this.onFocus && !noDataFormat) {
            // console.log('format', value);
            // xiquanquan
            value = formatNumber(value);
        } else {
            //如果不显示千分位
            if (!this.formatDocVO.useMil) {
                value = value.replace(/,/g, '');
            } else {
                value = value.replace(/,/g, this.formatDocVO.milSymbol);
            }
        }
        //校验信息的控制
        if (!verify) {
            errorMsg = (
                <span className="input-error-message">{this.state.json['base-ncnumber-0006'] || '请输入合法的数据！'}</span>
            );
            errorBorder = 'error-border';
        }
        //页面状态区分
        return (
            <div
                onMouseDown={() => {
                    this.mouseDown = true;
                }}
                onKeyDown={e => {
                    // backspace delete
                    if (e.keyCode === 46 || e.keyCode === 8) {
                        this.deleteTrigger = e.keyCode === 46 ? 'delete' : 'backspace';
                    }
                }}
                ref={numberDom => { this.numberDom = numberDom; }}
                className='base-number-wrapper'
            >
                <Calculator
                    // 用传下来的value 没有格式
                    value={others.value}
                    calculateHandle={value => {
                        scale = Number(scale) > 0 ? Number(scale) : 0;
                        if (value && value.includes('.')) {
                            value = Big(value || "0").round(scale).toString();
                        }
                        // TODO event 对象的整理
                        this.handleChange.call(this, value, { target: this.numberDom });
                    }}
                >
                    <FormControl
                        fieldid={getSysFieldid(fieldid)}
                        className="number-formcontrol"
                        style={style}
                        autoComplete="off"
                        {...others}
                        type="text"
                        value={value}
                        onChange={this.handleChange.bind(this)}
                        onKeyDown={this.handleKeyDown.bind(this)}
                        onBlur={(value, e) => this.handleBlur.call(this, value, e)}
                        onFocus={this.handleFocus}
                        maxlength={undefined}
                    />
                </Calculator>
                {suffix && <span style={{ lineHeight: '30px' }}>{suffix}</span>}
            </div>
        );
    }
}

NumberInput.propTypes = propTypes;
NumberInput.defaultProps = defaultProps;

export default NumberInput;
